<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Edit Order information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout xs4 row wrap>
              <v-flex pa-2>
                <v-autocomplete
                  v-model="updateForm.sent_outlet_id_fk"
                  :label="`${$t('Sent Outlet')} *`"
                  hide-details
                  :items="transferOutletsList"
                  box
                  data-vv-name="Sent Outlet"
                  background-color="white"
                  :error="errors.has('Sent Outlet')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs4 pa-2>
                <v-autocomplete
                  v-model="updateForm.asset_type"
                  :items="assetTypes"
                  :label="`${$t('Asset Type')} *`"
                  box
                  readonly
                  hide-details
                  background-color="white"
                  :error="errors.has('asset_type')"
                  data-vv-name="asset_type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs4 class="pa-2">
                <v-menu v-model="billDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="updateForm.bill_date"
                    :label="`${$t('Bill Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="bill_date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('bill_date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="billDateMenu = false" v-model="updateForm.bill_date" />
                </v-menu>
              </v-flex>

              <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Current ASSET %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
              <v-flex v-if="updateForm.asset_type === 'Current'" xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex class="form-table-content">
                    <v-layout row>
                      <v-flex xs2 pa-2>#</v-flex>
                      <v-flex xs10 pa-2>{{ $t('Product') }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 class="form-table-content">
                    <v-layout row>
                      <v-flex xs5 pa-2 v-if="hasCollection">{{ $t('Collections') }}</v-flex>
                      <v-flex pa-2>{{ $t('Quantity') }}</v-flex>
                      <v-flex pa-2 v-if="settings.product_expiry === 'Active'">{{ $t('Expiration Date') }}</v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs1 style="padding-top: 3px" class="form-table-content">
                    <v-tooltip top>
                      <v-btn label @click="addRow()" small slot="activator" icon color="green">
                        <v-icon color="white">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex>
                      <v-layout row>
                        <v-flex xs2 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                          index + 1
                        }}</v-flex>
                        <v-flex xs10 class="pa-1">
                          <v-autocomplete
                            v-model="updateForm.product_id_fk[index]"
                            :label="`${$t('Product')} *`"
                            :items="purchaseProductsList"
                            hide-details
                            box
                            :data-vv-name="'Product' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Product' + (index + 1))"
                            v-validate="'required'"
                            @input="findCollections(index)"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6>
                      <v-layout row>
                        <v-flex xs6 pa-1 v-if="hasCollection">
                          <v-autocomplete
                            v-model="updateForm.collection_id_fk[index]"
                            :label="$t('Collections')"
                            :items="collections[index]"
                            item-text="collection_name"
                            item-value="collection_id"
                            hide-details
                            box
                            :disabled="collections[index] && collections[index].length === 0"
                            :data-vv-name="'Collections' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Collections' + (index + 1))"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateForm.purchase_quantity[index]"
                            :label="`${$t('Quantity')} *`"
                            hide-details
                            box
                            :data-vv-name="'Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Quantity' + (index + 1))"
                            v-validate="'required|decimal:3|min_value:0'"
                          />
                        </v-flex>
                        <v-flex v-if="settings.product_expiry === 'Active'" class="pa-1">
                          <v-menu
                            offset-y
                            v-model="expireDateMenu[index]"
                            full-width
                            max-width="290"
                            :close-on-content-click="false"
                          >
                            <v-text-field
                              slot="activator"
                              :value="updateForm.expire_date[index]"
                              :label="`${$t('Expiration Date')}`"
                              prepend-inner-icon="event"
                              box
                              readonly
                              hide-details
                              name="expire_date"
                              background-color="white"
                              autocomplete="off"
                              :error="errors.has('expire_date' + (index + 1))"
                              v-validate="'date_format:yyyy-MM-dd'"
                            />
                            <v-date-picker
                              @change="expireDateMenu[index] = false"
                              v-model="updateForm.expire_date[index]"
                            />
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex
                      xs1
                      :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                      style="text-align: center"
                    >
                      <v-tooltip top>
                        <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>
                      <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                        <v-btn label @click="addRow()" small flat slot="activator" icon>
                          <v-icon size="28" color="green">add_circle</v-icon>
                        </v-btn>
                        <span>{{ $t('Add new row') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>

              <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Fixed ASSET %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
              <v-flex v-else-if="updateForm.asset_type === 'Fixed'" xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex xs1 class="pa-2 form-table-content">#</v-flex>
                  <v-flex xs2 class="pa-2 form-table-content">{{ $t('Product') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('Lifespan') }}</v-flex>
                  <v-flex xs2 class="pa-2 form-table-content">{{
                    `${$t('Salvage Price')} (${systemCurrency})`
                  }}</v-flex>
                  <v-flex xs2 class="pa-2 form-table-content">{{
                    `${$t('Purchase Price')} (${systemCurrency})`
                  }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('Quantity') }}</v-flex>
                  <v-flex xs2 class="pa-2 form-table-content">{{ `${$t('Total')} (${systemCurrency})` }}</v-flex>
                  <v-flex xs1 style="padding-top: 3px" class="form-table-content">
                    <v-tooltip top>
                      <v-btn label @click="addRow()" small slot="activator" icon color="green">
                        <v-icon color="white">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex xs1 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                      index + 1
                    }}</v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-autocomplete
                        v-model="updateForm.product_id_fk[index]"
                        :label="`${$t('Product')} *`"
                        :items="assetsList"
                        hide-details
                        box
                        :data-vv-name="'Product' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Product' + (index + 1))"
                        v-validate="'required'"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model.number="updateForm.lifespan[index]"
                        :label="`${$t('Lifespan')} *`"
                        hide-details
                        box
                        :data-vv-name="'Lifespan' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Lifespan' + (index + 1))"
                        v-validate="'required|decimal:3|min_value:0|max_value:99'"
                      />
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-text-field
                        v-model.number="updateForm.salvage_price[index]"
                        :label="`${$t('Salvage Price')} *`"
                        hide-details
                        box
                        :data-vv-name="'Salvage Price' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Salvage Price' + (index + 1))"
                        v-validate="'required|decimal:3|min_value:0'"
                      />
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-text-field
                        v-model.number="updateForm.purchase_price[index]"
                        :label="`${$t('Purchase Price')} *`"
                        hide-details
                        box
                        :data-vv-name="'Purchase Price' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Purchase Price' + (index + 1))"
                        v-validate="'required|decimal:3|min_value:0'"
                        @input="
                          calculateTotal(index, updateForm.purchase_quantity[index], updateForm.purchase_price[index])
                        "
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model.number="updateForm.purchase_quantity[index]"
                        :label="`${$t('Quantity')} *`"
                        hide-details
                        box
                        :data-vv-name="'Quantity' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Quantity' + (index + 1))"
                        v-validate="'required|decimal:3|min_value:0'"
                        @input="
                          calculateTotal(index, updateForm.purchase_quantity[index], updateForm.purchase_price[index])
                        "
                      />
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-text-field
                        v-model.number="updateForm.total[index]"
                        :label="$t('Total')"
                        hide-details
                        box
                        readonly
                        background-color="white"
                      />
                    </v-flex>
                    <v-flex
                      xs1
                      :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                      style="text-align: center"
                    >
                      <v-tooltip top>
                        <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>
                      <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                        <v-btn label @click="addRow()" small flat slot="activator" icon>
                          <v-icon size="28" color="green">add_circle</v-icon>
                        </v-btn>
                        <span>{{ $t('Add new row') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      rowNumbers: 0,
      billDateMenu: false,
      expireDateMenu: [false],
      expireDate: [],
      updateForm: {
        purchase_id: 0,
        sent_outlet_id_fk: '',
        bill_date: '',
        asset_type: '',
        product_id_fk: [],
        collection_id_fk: [],
        purchase_quantity: [],
        expire_date: [''],
        lifespan: [],
        salvage_price: [],
        purchase_price: [],
        total: []
      },
      collections: []
    }
  },

  computed: {
    ...mapGetters({
      receiveInfo: 'receives/getReceiveInfo',
      purchaseProductsList: 'products/getFullPurchaseProductsList',
      transferOutletsList: 'transfers/getTransferOutletsList',
      assetTypes: 'destructedAssets/getAssetTypes',
      settings: 'configurations/getSystemSettings',
      assetsList: 'fixedAssets/getFullTransferFixedAssetsList'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.rowNumbers = this.receiveInfo.data_detail.length
          this.updateForm.sent_outlet_id_fk = this.receiveInfo.data.sent_outlet_id_fk
          this.updateForm.bill_date = this.receiveInfo.data.bill_date
          this.updateForm.asset_type = this.receiveInfo.data.asset_type
          this.updateForm.purchase_id = Number(this.receiveInfo.data.purchase_id)

          this.updateForm.product_id_fk = []
          this.updateForm.collection_id_fk = []
          this.updateForm.purchase_quantity = []
          this.updateForm.expire_date = []
          this.expireDate = []
          this.updateForm.lifespan = []
          this.updateForm.salvage_price = []
          this.updateForm.purchase_price = []
          this.updateForm.total = []

          this.receiveInfo.data_detail.forEach((c, index) => {
            this.updateForm.product_id_fk.push(Number(c.product_id_fk))
            this.updateForm.collection_id_fk.push(c.collection_id_fk)
            if (this.updateForm.collection_id_fk[index]) {
              this.findCollections(index)
              this.updateForm.purchase_quantity.push(c.purchase_collection_quantity)
            } else {
              this.updateForm.purchase_quantity.push(c.purchase_quantity)
            }
            this.updateForm.expire_date.push(c.expire_date)
            this.updateForm.lifespan.push(c.lifespan)
            this.updateForm.salvage_price.push(c.salvage_price)
            this.updateForm.purchase_price.push(c.purchase_price)
            this.updateForm.total.push(c.purchase_quantity * c.purchase_price)
            this.expireDate[index] = c.expire_date
          })

          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateReceiveInfo: 'receives/updateReceiveInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    addRow() {
      this.updateForm.expire_date[this.rowNumbers] = ''
      this.expireDateMenu[this.rowNumbers] = false
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.updateForm.product_id_fk.splice(index, 1)
      this.updateForm.collection_id_fk.splice(index, 1)
      this.updateForm.purchase_quantity.splice(index, 1)
      this.updateForm.expire_date.splice(index, 1)
      this.expireDateMenu.splice(index, 1)
      this.updateForm.lifespan.splice(index, 1)
      this.updateForm.salvage_price.splice(index, 1)
      this.updateForm.purchase_price.splice(index, 1)
      this.updateForm.total.splice(index, 1)
    },

    findCollections(index) {
      const filteredProduct = this.purchaseProductsList.filter(
        item => item.value === this.updateForm.product_id_fk[index]
      )[0]
      this.collections[index] = filteredProduct.collections
    },

    findCollection(index) {
      return this.collections[index].filter(item => item.collection_id === this.updateForm.collection_id_fk[index])[0]
    },

    collectionQuantity(index) {
      return this.findCollection(index).collection_quantity
    },

    calculateTotal(index, quantity, thePrice) {
      let qtt = 0
      let price = 0
      let sumPrice = 0

      if (!isNaN(quantity)) {
        qtt = quantity
      }
      if (!isNaN(thePrice)) {
        price = thePrice
      }

      sumPrice = qtt * price
      sumPrice = Number(sumPrice)
      this.updateForm.total[index] = sumPrice.toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('sent_outlet_id_fk', this.updateForm.sent_outlet_id_fk)
            formData.append('asset_type', this.updateForm.asset_type)

            this.updateForm.product_id_fk.forEach((p, index) => {
              formData.append('product_id_fk[' + [index] + ']', p)
              formData.append('collection_id_fk[' + index + ']', this.updateForm.collection_id_fk[index] || '')
              if (this.updateForm.collection_id_fk[index]) {
                formData.append('purchase_collection_quantity[' + index + ']', this.updateForm.purchase_quantity[index])
                formData.append(
                  'purchase_quantity[' + index + ']',
                  (this.updateForm.purchase_quantity[index] * this.collectionQuantity(index)).toFixed(2)
                )
              } else {
                formData.append('purchase_collection_quantity[' + index + ']', '')
                formData.append('purchase_quantity[' + index + ']', this.updateForm.purchase_quantity[index])
              }
            })

            this.updateForm.lifespan.forEach((p, index) => {
              formData.append('lifespan[' + [index] + ']', p)
            })

            this.updateForm.salvage_price.forEach((p, index) => {
              formData.append('salvage_price[' + [index] + ']', p)
            })

            this.updateForm.purchase_price.forEach((p, index) => {
              formData.append('purchase_price[' + [index] + ']', p)
            })

            this.updateForm.purchase_quantity.forEach((q, index) => {
              formData.append('purchase_quantity[' + [index] + ']', q)
            })

            this.updateForm.expire_date.forEach((ed, index) => {
              formData.append('expire_date[' + [index] + ']', ed || '')
            })

            let payload = { id: this.updateForm.purchase_id, formData }
            this.updateReceiveInfo(payload)
              .then(() => {
                this.rowNumbers = 1
                this.expireDateMenu = [false]
                this.updateForm.product_id_fk = []
                this.updateForm.purchase_quantity = []
                this.updateForm.expire_date = ['']
                this.expireDate = ['']
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
